<img class="img-items" src="assets/events.svg">
<div class="container">
    <div *ngIf="allOwn" class="row">
        <div class="col-12">
            <div class="heading">
                <h1>Own items</h1>
                <h5>All items created by users</h5>
                <div *ngIf="themes$ | async as themes" class="d-flex mt-4">
                    <input (keyup)="filter('name', $event.target.value)" class="form-control mr-3 w-50"
                           placeholder="Search by name"
                           type="text">
                    <select (change)="filter('theme', $event.target.value)" class="form-control w-50">
                        <option value="" selected>Filter by theme</option>
                        <option *ngFor="let theme of themes" [value]="theme.name">{{theme.name}}</option>
                    </select>
                </div>
            </div>
            <div *ngFor="let item of filteredItems" class="item px-3">
                <div class="d-flex">
                    <div class="item-type" placement="top" ngbTooltip="{{item.type}}" [ngClass]="{
                    'food': item.type === 'food',
                    'beverages': item.type === 'beverages',
                    'useful': item.type === 'useful'
                    }">
                        <i class="fas" [ngClass]="{
                    'fa-hamburger': item.type === 'food',
                    'fa-glass-martini-alt': item.type === 'beverages',
                    'fa-wrench': item.type === 'useful'
                    }"></i>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="item-name">{{item.name}}</div>
                        <div class="item-theme">{{item.theme}}</div>
                    </div>
                </div>
                <a [routerLink]="'/items/'+item.id" class="d-flex">
                    <i class="fas fa-plus"></i>
                </a>
            </div>
        </div>
    </div>
</div>
